// src/main.tsx (or index.tsx)
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'; // Import BrowserRouter
import WrappedApp from './App';
import './index.css'; // Assuming you have an index.css for global styles/Tailwind

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter> {/* Wrap WrappedApp with BrowserRouter */}
      <WrappedApp />
    </BrowserRouter>
  </React.StrictMode>,
);